import { render, staticRenderFns } from "./WorkflowStatusCategory.vue?vue&type=template&id=6eb3a955&scoped=true"
import script from "./WorkflowStatusCategory.vue?vue&type=script&lang=js"
export * from "./WorkflowStatusCategory.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStatusCategory.vue?vue&type=style&index=0&id=6eb3a955&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb3a955",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
